export default "__VITE_ASSET__069443ab__"